<template>
  <div class="buy-cart-icon-con">
    <span class="text red-text" v-if="buyCartCount>0 && buyCartCount<10">{{ buyCartCount }}</span>
    <span class="text red-text-long" v-if="buyCartCount>9">{{ buyCartCount>99 ? '99+' : buyCartCount }}</span>
    <div class="icon-con" @click.self="goBuyCart"></div>
  </div>
</template>

<script>
import { mapGetters} from 'vuex';
export default {
  data(){
    return {

    }
  },
  computed:{
    ...mapGetters([
      'buyCartCount'
    ])
  },
  created(){
    this.$store.dispatch('sg/getBuyCartCount')
  },
  methods: {
    goBuyCart(){
      this.$router.push({name: 'shoppingCart'})
    },
  }
}
</script>

<style lang="less" scoped>
.buy-cart-icon-con{
  position: fixed;width: 63px;height: 63px;
  bottom: 68px;right: 6px;z-index: 1;
  .text{
    position: absolute;top: 10px;right: 12px;
    width: 24px;height: 12px;color: #fff;
    background-color: #f23030;font-size: 9px;line-height: 12px;text-align: center;
    &.red-text{
      border-radius: 50%;width: 12px;height: 12px;
    }
    &.red-text-long{
      border-radius: 6px;width: 24px;height: 12px;
    }
  }
  .icon-con{
    width: 63px;height: 63px;
    background: url("./img/buy-cart-icon.png") no-repeat 50% 50%;
    background-size: 100%;
  }
}
</style>